import { type LoaderProps, default as Loader } from '@CS/components/Loader';

export default (loading: boolean, props?: LoaderProps) =>
  loading ? <Loader {...props} /> : null;
